module.exports = __webpack_public_path__ + "img/car-side-solid.c9405aea.svg";